export enum ViolationsSupportedActions {
  Exempt = 'exempt',
  Waive = 'waive',
  AddOwner = 'addOwner',
  RemoveOwner = 'removeOwner',
  SetAccess = 'setAccess',
  ListAccess = 'listAccess',
  Delete = 'delete',
  SendEmail = 'sendEmail',
  Quarantine = 'quarantine',
  Unquarantine = 'unquarantine',
  Start = 'start',
  Stop = 'stop',
  GetResourceDefinition = 'getResourceDefinition',
  SecureFlowSteps = 'secureFlowSteps',
  GetResourceSbomFile = 'getResourceSbomFile',
  GetRawResource = 'getRawResource',
  PowerplatformSetCopilotAuthentication = 'powerplatformSetCopilotAuthentication',
  PowerplatformGetRawFlowRuns = 'powerplatformGetRawFlowRuns',
  ChatGptEnterpriseDeleteGptAction = 'chatGptEnterpriseDeleteGptAction',
  ChatGptEnterpriseIsolateGptAction = 'chatGptEnterpriseIsolateGptAction',
  ChatGptEnterpriseDeleteGptKnowledgeAction = 'chatGptEnterpriseDeleteGptKnowledgeAction',
  ChatGptEnterpriseGetGptKnowledgeFileUrlAction = 'chatGptEnterpriseGetGptKnowledgeFileUrlAction',
  ChatGptEnterpriseDeleteUserCanvasAction = 'chatGptEnterpriseDeleteUserCanvasAction',
  ChatGptEnterpriseGetUserCanvasAction = 'chatGptEnterpriseGetUserCanvasAction',
}
